export class Counter {
    value = -1;
    up() {
        return ++this.value;
    }
}
//# sourceMappingURL=Counter.js.map